<template>
  <div class="gnb" style="right:0;">
    <h3>
      <a href="#" @click.prevent="toggleGnb">
        <img src="@/assets/img/popClose2.png" alt="닫기" />
      </a>
      <span>Rev.150</span>
    </h3>
    <ul>
      <li>
        <a href="#" @click.prevent="goQuiz">
          <div class="icon">
            <img src="@/assets/img/gnb1.png" alt="quiz" />
          </div>Quiz
        </a>
      </li>
      <li>
        <a href="#" @click.prevent="goSurvey">
          <div class="icon">
            <img src="@/assets/img/gnb2.png" alt="Surey" />
          </div>Survey
        </a>
      </li>
      <li>
        <a href="#" @click.prevent="goQna">
          <div class="icon">
            <img src="@/assets/img/gnb3.png" alt="Q&A" />
          </div>Q&A
        </a>
      </li>
      <li>
        <a href="#" @click.prevent="goShare">
          <div class="icon">
            <img src="@/assets/img/gnb100.png" alt="Share" />
          </div>Share
        </a>
      </li>
      <!-- <li>
        <a href="#" @click.prevent="goSpot">
          <div class="icon">
            <img src="@/assets/img/gnb5.png" alt="Spot" />
          </div>Spot
        </a>
      </li>-->
    </ul>
  </div>
</template>

<script>
import router from "@/router";
export default {
  methods: {
    toggleGnb: function() {
      this.$store.dispatch("toggleGnb");
    },
    goQuiz: function() {
      this.$store.dispatch("toggleGnb");
      // router.push("/quiz/main");
      router.push("/non/fulllist/quiz");
    },
    goSurvey: function() {
      this.$store.dispatch("toggleGnb");
      // router.push("/poll/main");
      router.push("/non/fulllist/poll");
    },
    goQna: function() {
      this.$store.dispatch("toggleGnb");
      router.push("/qna/fulllist");
    },
    goShare: function() {
      this.$store.dispatch("toggleGnb");
      router.push("/slide/list");
    },
    goSpot: function() {
      this.$store.dispatch("toggleGnb");
      router.push("/qna/fulllist");
    }
  }
};
</script>


<style lang="scss" scoped>
.gnb {
  position: relative;
  position: absolute;
  right: -100%;
  top: 0;
  height: 100vh;
  background: #ffffff;
  z-index: 102;
  width: 70%;
}
.gnb h3 {
  text-align: left;
  color: #000;
  font-size: 17px;
  line-height: 1.3em;
  height: 55px;
  line-height: 55px;
  background: #009d96;
  padding-left: 35px;
}
.gnb h3 a {
  float: left;
  display: block;
  width: 37px;
  text-align: center;
}
.gnb h3 img {
  width: 16px;
}
.gnb h3 span {
  float: right;
  color: wheat;
  font-size: 0.5em;
  margin-right: 5px;
}
.gnb ul {
  font-size: 0;
  border-top: 1px solid #e3e3e3;
}
.gnb ul li {
  border-bottom: 1px solid #e3e3e3;
}
.gnb ul li:nth-child(2n + 1) {
  border-right: 1px solid #e3e3e3;
}
.gnb ul li .icon {
  display: inline-block;
  vertical-align: middle;
  width: 37px;
  margin-right: 22px;
  text-align: center;
}
.gnb ul li .icon img {
}
.gnb ul li:nth-child(1) .icon img {
  width: 32px;
}
.gnb ul li:nth-child(2) .icon img {
  width: 35px;
}
.gnb ul li:nth-child(3) .icon img {
  width: 36px;
}
.gnb ul li:nth-child(4) .icon img {
  width: 30px;
}
.gnb ul li:nth-child(5) .icon img {
  width: 36px;
}
.gnb ul li:nth-child(6) .icon img {
  width: 36px;
}

.gnb ul li a {
  width: 100%;
  display: block;
  text-align: left;
  color: #666666;
  font-size: 15px;
  height: 80px;
  line-height: 80px;
  padding-left: 35px;
  font-weight: 700;
}
</style>